import { isWithinInterval } from 'date-fns'
import { BookingFeature, BookingBookingPayload } from '../../../services/booking/types'

import { isHex } from '../../../utils/app-utils'
import { BookingAvailability } from '../consts'
import { BookingAvailabilityItem } from '../types'
import { DeskStatusColor, DeskStatusID } from './enums'
import { formatDateWithTimeZone } from '../../../utils/date-utils'
import { BookingDeskPortPosition } from '../Shared/enums'

export const getLabelCoords = (
  featureDetail: BookingFeature,
  derivedPosition: 'Top' | 'Right' | 'Bottom' | 'Left'
) => {
  if (featureDetail.floorPlanId !== 4) {
    // Any but Manchester / Spring Gardens 10th Floow
    return {
      x: featureDetail.x + (derivedPosition === 'Right' ? 10 : 40),
      y: featureDetail.y + featureDetail.height / 2 + 5,
    }
  }
  let y = featureDetail.y + featureDetail.height / 2 + 5
  let xAdd = 0
  switch (derivedPosition) {
    case 'Top':
    case 'Bottom':
      xAdd = 5
      break
    case 'Right':
      xAdd = 12
      break
    case 'Left':
    default:
      xAdd = 0
      break
  }
  let x = featureDetail.x + featureDetail.width / 2 - xAdd
  if (derivedPosition === 'Top') {
    y += 10
  } else if (derivedPosition === 'Bottom') {
    y -= 10
  }
  if (featureDetail.label.length > 1) {
    x -= 10
  }
  return { x, y }
}

export const deskColour = (
  featureDetail: BookingFeature,
  isOwnBooking: boolean
) => {
  if (featureDetail.statusId === DeskStatusID.UNAVAILABLE) {
    return DeskStatusColor.NOTACTIVE
  }
  if (isOwnBooking) {
    return DeskStatusColor.OWN_BOOKING
  }
  if (featureDetail.statusId === DeskStatusID.VACANT) {
    return isHex(featureDetail.fill) ? featureDetail.fill : DeskStatusColor.ACTIVE
  }
}

export const calculateAccessPosition = (
  featureDetail: BookingFeature,
  portBorderRadius: number
): {
  x: number
  y: number
  position: 'Top' | 'Right' | 'Bottom' | 'Left'
} => {
  if (portBorderRadius === 0) {
    return { x: 0, y: 0, position: 'Top' }
  }
  switch (Number(featureDetail.ports?.[0].x)) {
    case BookingDeskPortPosition.TOP:
      return { x: featureDetail.x + featureDetail.width / 2, y: featureDetail.y, position: 'Top' }
    case BookingDeskPortPosition.RIGHT:
      return {
        x: featureDetail.x + featureDetail.width,
        y: featureDetail.y + featureDetail.height / 2,
        position: 'Right',
      }
    case BookingDeskPortPosition.BOTTOM:
      return {
        x: featureDetail.x + featureDetail.width / 2,
        y: featureDetail.y + featureDetail.height,
        position: 'Bottom',
      }
    case BookingDeskPortPosition.LEFT:
    default:
      return {
        x: featureDetail.x,
        y: featureDetail.y + featureDetail.height / 2,
        position: 'Left',
      }
  }
}
